import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";

const detectSource = () => {
  try {
    const params = new URLSearchParams(window.location.search);
    if (params.has("gclid")) return "google_ads";
    if (params.has("fbclid")) return "facebook";
    const utm = (params.get("utm_source") || "").toLowerCase();
    if (utm) return utm.slice(0, 20);
    const ref = (document.referrer || "").toLowerCase();
    if (ref.includes("instagram")) return "instagram";
    if (ref.includes("facebook") || ref.includes("fb.")) return "facebook";
    if (ref.includes("google")) return "google_organico";
    if (ref.includes("whatsapp") || ref.includes("wa.me")) return "whatsapp";
    if (ref) return "referral";
    return "diretto";
  } catch {
    return "diretto";
  }
};

export const VisitTracker = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname.startsWith("/admin")) return;
    try {
      const day = new Date().toLocaleDateString("sv-SE");
      const key = `baianeira_visit_${day}`;
      if (localStorage.getItem(key)) return;
      localStorage.setItem(key, "1");
      api.post("/visits/hit", {
        page: pathname || "/",
        source: detectSource(),
        device: window.innerWidth < 768 ? "mobile" : "desktop",
      }).catch(() => {});
    } catch {
      /* localStorage non disponibile: ignora */
    }
  }, [pathname]);

  return null;
};

export default VisitTracker;
